// File: src/components/DashboardCard.tsx
import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';

import { BoxProps } from '@mui/material';

interface DashboardCardProps extends BoxProps {
  title: string;
  children: React.ReactNode;
}

export const DashboardCard: React.FC<DashboardCardProps> = ({ title, children, sx }) => {
  return (
    <Card sx={{ borderRadius: 2, boxShadow: 3, ...sx }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
        {children}
      </CardContent>
    </Card>
  );
};